/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Generic sidebar component configuration
 * @export
 * @interface SidebarComponentDto
 */
export interface SidebarComponentDto {
    /**
     * Component type identifier (PRICING_FILTERS, PRICING_VARIABLE_AND_FEES)
     * @type {string}
     * @memberof SidebarComponentDto
     */
    componentKey: string;
    /**
     * Configuration object - structure depends on componentKey
     * @type {object}
     * @memberof SidebarComponentDto
     */
    componentConfig: object;
}

/**
 * Check if a given object implements the SidebarComponentDto interface.
 */
export function instanceOfSidebarComponentDto(value: object): value is SidebarComponentDto {
    if (!('componentKey' in value) || value['componentKey'] === undefined) return false;
    if (!('componentConfig' in value) || value['componentConfig'] === undefined) return false;
    return true;
}

export function SidebarComponentDtoFromJSON(json: any): SidebarComponentDto {
    return SidebarComponentDtoFromJSONTyped(json, false);
}

export function SidebarComponentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SidebarComponentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'componentKey': json['componentKey'],
        'componentConfig': json['componentConfig'],
    };
}

export function SidebarComponentDtoToJSON(json: any): SidebarComponentDto {
    return SidebarComponentDtoToJSONTyped(json, false);
}

export function SidebarComponentDtoToJSONTyped(value?: SidebarComponentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'componentKey': value['componentKey'],
        'componentConfig': value['componentConfig'],
    };
}

